import { makeStyles } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const palette = require('../../theme/palette').default;

export const useAddOptionDialogStyles = makeStyles(theme => ({
  paper: {
    background: palette.white
  },
  input: {
    width: '100%'
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    paddingLeft: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  submitButton: {
    background: palette.buttons.purple,
    backgroundColor: palette.buttons.purple,
    color: palette.white,
    fontWeight: 'bold' as const,
    padding: theme.spacing(1),
    marginRight: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    '&:disabled': {
      opacity: 0.4,
      background: palette.buttons.purple,
      color: palette.white
    },
    '&:hover': {
      opacity: 0.8,
      background: palette.buttons.purple
    }
  }
}));

export default useAddOptionDialogStyles;
